import React, { useEffect, useRef } from 'react';
import gsap from 'gsap';

const Marquee = () => {
  const marqueeRef = useRef(null);

  useEffect(() => {
    const marqueeText = marqueeRef.current;
    if (!marqueeText) return;

    gsap.to(marqueeText, {
      xPercent: -50,
      ease: 'none',
      duration: 20,
      repeat: -1,
    });
  }, []);

  const text = 'PREMIUM • PUUR • PENOTTI • VAKMANSCHAP • ';

  return (
    <section className="py-16 overflow-hidden" style={{ backgroundColor: 'var(--atelier-black)' }}>
      <div ref={marqueeRef} className="whitespace-nowrap">
        <span
          className="inline-block text-6xl md:text-8xl font-light"
          style={{ color: 'var(--atelier-gold)' }}
        >
          {text.repeat(10)}
        </span>
      </div>
    </section>
  );
};

export default Marquee;